import React from 'react'
import PropTypes from 'prop-types'

import { IPR_VALUE_LIST, LOWER_TEETH, LOWER_TEETH_IN_BETWEEN, UPPER_TEETH, UPPER_TEETH_IN_BETWEEN } from '../../state/plan/const'
import Select from '../../../form/component/Select'


const IPRInstruction = ({ iprInstructionList, position, readOnly, changeIPRInstruction }) => {
    return (
        <div className="teeth-in-between-item">
            <Select
                object={iprInstructionList}
                readOnly={readOnly}
                onChange={(name, value) => {
                    if (!readOnly) {
                        changeIPRInstruction(name, value)
                    }
                }}
                valueList={IPR_VALUE_LIST}
                name={position}/>
        </div>
    )
}


const IPRInstructionList = ({ iprInstructionList, readOnly, changeIPRInstruction }) => {
    if (!iprInstructionList) {
        iprInstructionList = {}
    }
    return (
        <div>
            <div>
                {UPPER_TEETH.map(position => {
                    return <div key={position} className="teeth-label-item">{position}</div>
                })}
            </div>
            <div>
                <div className="teeth-in-between-start-end"/>
                {UPPER_TEETH_IN_BETWEEN.map(position => {
                    return (
                        <IPRInstruction
                            key={position}
                            position={position}
                            readOnly={readOnly}
                            iprInstructionList={iprInstructionList}
                            changeIPRInstruction={changeIPRInstruction}
                        />)
                })}
                <div className="teeth-in-between-start-end"/>
            </div>
            <div>
                <div className="teeth-in-between-start-end"/>
                {LOWER_TEETH_IN_BETWEEN.map(position => {
                    return (
                        <IPRInstruction
                            key={position}
                            position={position}
                            readOnly={readOnly}
                            iprInstructionList={iprInstructionList}
                            changeIPRInstruction={changeIPRInstruction}
                        />)
                })}
                <div className="teeth-in-between-start-end"/>
            </div>
            <div>
                {LOWER_TEETH.map(position => {
                    return <div key={position} className="teeth-label-item">{position}</div>
                })}
            </div>
        </div>
    )
}

IPRInstructionList.propTypes = {
    iprInstructionList: PropTypes.object,
    readOnly: PropTypes.bool.isRequired,
    changeIPRInstruction: PropTypes.func.isRequired,
}


export default IPRInstructionList



// WEBPACK FOOTER //
// ./src/modules/treatment/component/plan/IPRInstructionList.js